import { Gauge, Handshake, ShieldCheck, Trophy } from "lucide-react";

const standards = [
  { icon: Trophy, value: "40+", title: "Delivered projects", copy: "Experience built across real fields, demanding environments, and multidisciplinary briefs." },
  { icon: Gauge, value: "360°", title: "Integrated capability", copy: "Engineering, motorsport management, production, and gear connected through one accountable team." },
  { icon: ShieldCheck, value: "FIELD", title: "Evidence over assumption", copy: "We work close to machines, terrain, crews, and customers—where performance can be proven." },
  { icon: Handshake, value: "01", title: "Committed partner", copy: "Clear ownership, serious execution, and dedicated communication from first conversation to delivery." },
];

export const TrustSection = () => (
  <section className="trust-section section-pad" data-testid="trust-section">
    <div className="trust-intro">
      <p className="eyebrow" data-testid="trust-eyebrow">The MADMINUTE standard</p>
      <h2 data-testid="trust-heading">INNOVATION GETS ATTENTION.<br/><span>COMMITMENT EARNS TRUST.</span></h2>
      <p data-testid="trust-description">Our visuals move fast. Our work is grounded in discipline, field intelligence, and responsibility to the people who trust us with a brief.</p>
    </div>
    <div className="trust-grid">
      {standards.map(({ icon: Icon, value, title, copy }, index) => (
        <article key={title} data-testid={`trust-standard-${index + 1}`}>
          <div><Icon/><span>0{index + 1}</span></div>
          <strong>{value}</strong><h3>{title}</h3><p>{copy}</p>
        </article>
      ))}
    </div>
  </section>
);
